import {
  classList,
  classAdd,
  classEdit,
  classDelete,
} from '@/api/class_grade'

export default {
  async classList({ }, data) {
    return classList(data)
  },
  async classAdd({ }, data) {
    return classAdd(data)
  },
  async classEdit({ }, data) {
    return classEdit(data)
  },
  async classDelete({ }, data) {
    return classDelete(data)
  },
}
